export default "__VITE_ASSET__Uk6TTQEr__"